import * as Yup from 'yup';

export interface IExcluirFichaCadastral {
	numeroFicha: string;
	anoFicha: string;
}

export const initialValues: IExcluirFichaCadastral = {
	numeroFicha: '',
	anoFicha: '',
};

export const schema = Yup.object<IExcluirFichaCadastral>().shape({
	numeroFicha: Yup.string().required(`Campo Obrigatório: Número da Ficha.`),
	anoFicha: Yup.string().required(`Campo Obrigatório: Ano da Ficha Cadastral.`),
});
